import React from 'react';
import _ from 'lodash';
import ListItem from './ListItem';
import useFocus from './useFocus';

const SelectList = ({
  className,
  //selectName,
  itemsList,
  selectedState,
  type,
  displayKey,
  onClick,
  customComponent,
  onBlur,
  toLower
}) => {
  const [focus, setFocus] = useFocus(itemsList.length);
  return (
    <div
      className={className}
      onBlur={e => {
        onBlur(type, e);
      }}
    >
      {/*<span className="disabledOption">{selectName}</span>*/}
      {_.map(itemsList, (item, id) => {
        return (
          <ListItem
            key={id}
            keyValue={id}
            setFocus={setFocus}
            index={id}
            focus={focus === id}
            className={selectedState}
            onClick={onClick}
            type={type}
            item={item}
            displayKey={displayKey}
            toLower={toLower}
          />
        );
      })}
      {customComponent}
    </div>
  );
};

export default SelectList;
